<div class="modal-content">
    <h3>Histórico</h3>

    <div *ngIf="hasValue" class="container">
        <mat-table [dataSource]="audits" class="table-list" multiTemplateDataRows>
            <ng-container matColumnDef="id" class="table-list__column">
                <mat-header-cell *matHeaderCellDef class="header-name">ID</mat-header-cell>
                <mat-cell *matCellDef="let element" class="column-name">{{element.id}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="name" class="table-list__column">
                <mat-header-cell *matHeaderCellDef class="header-name">Nome do Cliente</mat-header-cell>
                <mat-cell *matCellDef="let element" class="column-name">{{element.name}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="cnpj" class="table-list__column">
                <mat-header-cell *matHeaderCellDef class="header-name">CNPJ</mat-header-cell>
                <mat-cell *matCellDef="let element" class="column-name">{{element.cnpj | cpfCnpj}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="doneBy" class="table-list__column">
                <mat-header-cell *matHeaderCellDef class="header-name">Feito por</mat-header-cell>
                <mat-cell *matCellDef="let element" class="column-name">{{getDoneBy(element)}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="action" class="table-list__column">
                <mat-header-cell *matHeaderCellDef class="header-name">Ação</mat-header-cell>
                <mat-cell *matCellDef="let element" class="column-name">{{getActionLabel(element.action)}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="actionDateTime" class="table-list__column">
                <mat-header-cell *matHeaderCellDef class="header-name">Data da Ação</mat-header-cell>
                <mat-cell *matCellDef="let element" class="column-name">{{element.actionDateTime}}</mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"></mat-row>
        </mat-table>
    </div>

    <h5 *ngIf="!hasValue">Nenhum registro foi encontrado</h5>
    
    <div mat-dialog-actions align="center" >
      <div class="value-edit-table__button-container">
        <fd-button mat-button fdSecondaryLarge [content]="'Fechar'" (trigger)="close()"></fd-button>
      </div>
    </div>
</div>

